import { NgTemplateOutlet } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { IconComponent } from '../icons/icon/icon.component'
import { EIcons } from '@shared/models'
import { ISummaryPanelRow, ISummaryPanelSection } from '@shared/models/ui/summary-panel.model'

@Component({
	standalone: true,
	selector: 'app-summary-panel',
	imports: [IconComponent, NgTemplateOutlet],
	templateUrl: './summary-panel.component.html',
	styleUrl: './summary-panel.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryPanelComponent {
	readonly title = input<string | undefined>(undefined)
	readonly rows = input<ISummaryPanelRow[]>([])
	readonly sections = input<ISummaryPanelSection[]>([])
	readonly density = input<'default' | 'compact'>('default')
	readonly showTitle = input(true)
	readonly EIcons = EIcons
}
